import ValidationError from '@/classes/errors/ValidationError';

function createErrorsByPackageId(errors) {
  return Object.entries(errors)
    .reduce((acc, [key, messages]) => {
      const keyMatchResult = key.match(/^(\d+)\.(.+)/i);

      if (!keyMatchResult) {
        return acc;
      }

      const [packageIndex] = keyMatchResult.slice(1);
      const record = this.selectedPackages[+packageIndex];

      if (!record) {
        return acc;
      }

      return {
        ...acc,
        [record.id]: messages,
      };
    }, {});
}

export default {
  openImportPackagesModal(
    { dispatch },
    {
      id,
      type,
    },
  ) {
    if (id) {
      dispatch('setProviderId', id);
      dispatch('setType', type);
      dispatch('getExternalPanelPackagesForImport', id);
    }

    dispatch('setIsShown', true);
  },
  closeImportPackagesModal({ dispatch }) {
    dispatch('setIsShown', false);
    dispatch('setClearState');
  },
  setProviderId({ commit }, value) {
    commit('SET_PROVIDER_ID', value);
  },
  setIsShown({ commit }, value) {
    commit('SET_IS_SHOWN', value);
  },
  setClearState({ commit }) {
    commit('SET_CLEAR_STATE');
  },
  setType({ commit }, value) {
    commit('SET_TYPE', value);
  },
  async getExternalPanelPackagesForImport({
    commit, rootGetters,
  }, id) {
    commit('SET_LOADING', true);

    try {
      const externalPanelPackages = await rootGetters['providers/getRepository']
        .getExternalPanelPackagesForImport({ externalPanelId: id });

      commit('SET_PACKAGES', externalPanelPackages);
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : e;

      commit('SET_ERRORS_MESSAGE', errorMessage);
      commit('SET_ERRORS_NOTIFY', true);
    } finally {
      commit('SET_ERRORS_NOTIFY', false);
      commit('SET_LOADING', false);
    }
  },
  setSearch({ commit }, value) {
    commit('SET_SEARCH', value);
  },
  setSelectedPackages({ commit }, value) {
    commit('SET_SELECTED_PACKAGE', value);
  },
  setMultiplier({ commit }, value) {
    commit('SET_MULTIPLIER', value);
  },
  setTableOptions({ commit }, value) {
    commit('SET_TABLE_OPTIONS', value);
  },
  async storeImportedPackages({
    commit,
    state,
    rootGetters,
    dispatch,
  }, { errorNotify }) {
    commit('SET_ERRORS', {});
    commit('SET_SAVE_BTN_LOADING', true);

    try {
      await rootGetters['providers/getRepository'].storeImportedPackages(state.providerId, state.selectedPackages);

      dispatch('providers/table/fetch', null, { root: true });
      dispatch('closeImportPackagesModal');
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : e;

      commit('SET_ERRORS_MESSAGE', errorMessage);

      if (e instanceof ValidationError) {
        commit('SET_ERRORS', createErrorsByPackageId(e.messages));
      }

      if (errorNotify) {
        errorNotify();
      }
    } finally {
      commit('SET_SAVE_BTN_LOADING', false);
    }
  },
};
